import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="border-t border-hairline">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-center gap-6 px-4 py-6 text-sm text-ink-soft">
        <Link to="/about">{t("footer.about")}</Link>
        <Link to="/contact">{t("footer.contact")}</Link>
        <Link to="/privacy">{t("footer.privacy")}</Link>
        <Link to="/terms">{t("footer.terms")}</Link>
      </div>
    </footer>
  );
};

export default Footer;
